import { Coins } from "lucide-react";

interface GoldWidgetProps {
  amount: number | null;
  currencyName: string | null;
  compact?: boolean;
}

/**
 * Legacy widget — kept for backward compatibility.
 * Economy is now inventory-based; currencies are inventory items.
 * This widget can still render if old adventures have currency_amount in state.
 */
export function GoldWidget({ amount, currencyName, compact }: GoldWidgetProps) {
  const name = currencyName || "Currency";
  const value = amount ?? 0;

  if (value === 0 && !currencyName) return null;

  if (compact) {
    return (
      <div className="flex items-center gap-1 text-muted-foreground">
        <Coins className="w-3 h-3 text-yellow-500" />
        <span className="text-foreground font-medium">{value}</span>
        <span className="text-[10px] opacity-60">{name}</span>
      </div>
    );
  }

  return (
    <div className="space-y-3">
      <div className="flex items-center gap-2">
        <Coins className="w-5 h-5 text-yellow-500" />
        <span className="text-lg font-bold text-foreground">{value}</span>
        <span className="text-sm text-muted-foreground">{name}</span>
      </div>
      <p className="text-xs text-muted-foreground">
        Currency is tracked as inventory items. This shows legacy balance.
      </p>
    </div>
  );
}
